import type { ReactNode } from 'react'

import Loading from '@/components/Loading'
import NotFound from '@/pages/NotFound'
import { usePausedOrg } from '@/utils/hooks/usePausedOrg'

/** Renders its page for annual-plan orgs; everyone else gets Page Not Found. */
export default function AnnualOnlyRoute({ children }: { children: ReactNode }) {
  const { isAnnualSubscriber, isLoading } = usePausedOrg()

  if (isLoading) return <Loading />
  if (!isAnnualSubscriber) return <NotFound />
  return <>{children}</>
}
